<template>
  <div id="root">
    <div class="layout">
      <portfolio-header></portfolio-header>
      <social-links></social-links>
      <sidebar-email></sidebar-email>
      <div id="content">
        <router-view />
        <portfolio-footer></portfolio-footer>
      </div>
    </div>
  </div>
</template>
<script>
import PortfolioHeader from './views/layout/PortfolioHeader'
import PortfolioFooter from './views/layout/PortfolioFooter'
import SocialLinks from './views/layout/SocialLinks'
import SidebarEmail from './views/layout/SidebarEmail'

export default {
  name: 'PortfolioApp',
  components: {
    PortfolioHeader,
    PortfolioFooter,
    SocialLinks,
    SidebarEmail
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss">

</style>
